export const cardHeaderThemes = {
  default: {
    thHeading: '',
    thIntro: 'mt-4',
    thTags: 'flex -mx-1 mt-4 reset-list',
    thTag: 'm-1',
  },
  destination: {
    thHeading: '',
    thIntro: 'mt-4',
    thTags: 'flex -mx-1 mt-4 reset-list',
    thTag: 'm-1',
  },
  landing: {
    thHeading: '',
    thIntro: 'mt-4',
    thTags: 'flex -mx-1 mt-4 reset-list',
    thTag: 'm-1',
  },
  thumbnail: {
    thHeading: '',
    thIntro: 'mt-4',
    thTags: 'flex -mx-1 mt-4 reset-list',
    thTag: 'm-1',
  },
};
